import { useQuery } from '@tanstack/react-query'
import apiClient from '@app/config/axios.config'
import { Endpoint } from '@app/config/endpoints'
import type {
  SelectedElementProfileResponse,
  SelectedElementProfileRequest,
} from '../types/riskProfileSelected.types'

export const SELECTED_ELEMENT_PROFILE_QUERY_KEY = 'selected-element-profile'

const fetchSelectedElementProfile = async (
  request: SelectedElementProfileRequest,
): Promise<SelectedElementProfileResponse> => {
  const { data } = await apiClient.post<SelectedElementProfileResponse>(
    `${Endpoint.riskProfile}/assets/${request.asset_type}/${request.aggregate_id}`,
    {
      hazard_group_filter: request.hazard_group_filter || [],
      hazards: request.hazards || [],
    },
  )
  return data
}

export const useSelectedElementProfileQuery = (request: SelectedElementProfileRequest | null) => {
  return useQuery({
    queryKey: [SELECTED_ELEMENT_PROFILE_QUERY_KEY, request],
    queryFn: () => fetchSelectedElementProfile(request!),
    enabled: request?.aggregate_id !== undefined && request?.asset_type !== undefined,
  })
}
